<template>
    <v-flex>
        <v-list v-if="!pageLoading">
            <template v-for="(item, index) in items">
                <v-divider
                    :key="'divider' + index"
                    v-if="index > 0"
                ></v-divider>
                <v-list-tile
                    class="item"
                    :key="item.type"
                    @click="toDetail(item.type)"
                >
                    <v-list-tile-content>
                        <v-list-tile-title>
                            {{ item.label }}
                        </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action class="item-info">
                        <v-list-tile-action-text class="mr-2">
                            {{ item.text }}
                        </v-list-tile-action-text>
                        <v-icon>
                            {{ arrowIcon }}
                        </v-icon>
                    </v-list-tile-action>
                </v-list-tile>
            </template>
            <template
                v-if="
                    pageParent === 'password' && !items.length && !pageLoading
                "
            >
                <v-list-tile class="item-custom">
                    <v-list-tile-content>
                        <v-list-tile-title
                            class="body-1 red--text text--lighten-1"
                        >
                            {{ lang.custom_support_notice }}
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </template>
        </v-list>
        <v-dialog v-model="visible">
            <v-card color="error" dark>
                <v-card-text>
                    <v-layout align-center>
                        <span class="subheading">
                            {{ lang.get_data_fail_tips }}
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="white"
                            fab
                            small
                            light
                            @click="visible = false"
                        >
                            <v-icon>fas fa-times</v-icon>
                        </v-btn>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-flex>
</template>
<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
export default {
    name: "Index",
    data() {
        return {
            visible: false
        };
    },
    computed: {
        ...mapState(["securities", "pageParent", "pageLoading", "params"]),
        ...mapGetters(["lang", "isRtl"]),
        arrowIcon() {
            return this.isRtl ? "fas fa-chevron-left" : "fas fa-chevron-right";
        },
        items() {
            let tmp = this.securities.map(item => {
                return Object.assign({}, item, {
                    label: this.getLabel(item.type),
                    text: item.setted
                        ? item.type === "question"
                            ? this.lang.security_setted_text
                            : item.value
                        : this.lang.security_unset_text
                });
            });
            return this.pageParent === "password"
                ? tmp.filter(v => v.setted)
                : tmp;
        },
        action() {
            let tmp;
            if (this.pageParent === "security") {
                tmp = this.getHomeSecurities;
            } else if (this.pageParent === "password") {
                tmp = this.getUserSecurities;
            }
            return tmp;
        }
    },
    methods: {
        ...mapActions(["getHomeSecurities", "getUserSecurities"]),
        ...mapMutations({
            changePageLoading: "CHANGE_PAGE_LOADING",
            toggleToolbarBackBtn: "TOGGLE_TOOLBAR_BACK_BTN"
        }),
        toDetail(name) {
            this.$router.push({
                name,
                query: Object.assign({}, this.params, {
                    t: Date.now()
                })
            });
        },
        getData() {
            this.action()
                .then(() => {
                    this.changePageLoading(false);
                })
                .catch(() => {
                    this.visible = true;
                });
        },
        getLabel(type) {
            let tmp;
            switch (type) {
                case "mobile":
                    tmp = this.lang.security_phone_label;
                    break;
                case "email":
                    tmp = this.lang.security_email_label;
                    break;
                case "question":
                    tmp = this.lang.security_question_label;
                    break;
            }
            return tmp;
        }
    },
    created() {
        if (this.pageParent === "password") {
            this.toggleToolbarBackBtn(true);
        }
        this.getData();
    }
};
</script>
<style lang="scss">
.item-info {
    flex-direction: row !important;
    align-items: center !important;
}
.item-custom {
    .v-list__tile,
    .v-list__tile__title {
        height: auto;
        white-space: normal;
    }
}
</style>
